import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { OrganizationSelectStore } from './organization-select.store';
import { fb } from '../../../shared/shared.global-service';
import { AppFormGroup } from '../../../../utils/form.utils';
import { SelectInputComponent } from '../../../../components/kit/input/select-input/select-input.component';

@Component({
    selector: 'app-organization-select',
    templateUrl: './organization-select.component.html',
    styleUrls: ['./organization-select.component.scss'],
    providers: [OrganizationSelectStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectInputComponent,
    ],
})
export class OrganizationSelectComponent {

    public readonly store = inject(OrganizationSelectStore);

    protected form = new AppFormGroup({
        organization: fb.control<number | null>(null),
    });

    constructor() {
        this.form.controls.organization.markAllAsTouched();

        effect(() => {
            const selected = this.store.data.getSelectedOrganizationId();
            this.form.patchValue({ organization: selected }, { isCodeUpdate: true });
        });

        // The server preference may name an organization the user no longer belongs to; the store then
        // falls back to another organization, so the field must display the organization actually in use.
        effect(() => {
            const selected = this.store.globalGlobalStore.organizationStore.selectedId() || null;
            if (this.form.controls.organization.value !== selected) {
                this.form.patchValue({ organization: selected }, { emitEvent: false, isCodeUpdate: true });
            }
        });
    }

    protected organizationSelected(value: unknown): void {
        if (!value || typeof value !== 'object' || !('id' in value)) return;

        const organizationId = Number(value.id);
        if (organizationId) {
            this.store.setOrganizationId(organizationId);
        }
    }

}
